import { useState } from 'react';
import Table from 'react-bootstrap/Table';
import { Spinner } from 'react-bootstrap';
import CommProfileHeader from '../CommProfileHeader';
import {
  useDeleteAdditionalService,
  useGetAdditionalServiceList,
} from '../../apiEndpoints/exhibitorApiEndpoints';
import AddAdditionalService from './AddAdditionalService';
import CommonStatus from '../../../../Components/Common/CommonStatus';
import moment from 'moment';

const AdditionalService = () => {
  const [toggle, setToggle] = useState<boolean>(false);
  const { data, isLoading } = useGetAdditionalServiceList();
  const { mutate } = useDeleteAdditionalService();

  return (
    <>
      <CommProfileHeader
        addHeadingTitle={`Add Additional Service`}
        listHeadingTitle='Additional Service List'
        createBtnText='Add Item'
        toggle={toggle}
        setToggle={setToggle}
      />
      <div className='profile-right-side px-3 py-3'>
        {toggle ? (
          <AddAdditionalService handleClose={() => setToggle(!toggle)} />
        ) : (
          <div className='profile-right-info pt-3 ps-2'>
            {isLoading ? (
              <div className='text-center mt-3'>
                <Spinner animation='border' variant='primary' />
              </div>
            ) : (
              <>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th className='text-center'>SL.</th>
                      <th className='text-center'>Date</th>
                      <th className='text-center'>Service Name</th>
                      <th className='text-center'>Quantity</th>
                      <th className='text-center'>Price</th>
                      <th className='text-center'>Status</th>
                      {/* <th className='text-center'>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {data?.data && data?.data?.length ? (
                        data?.data?.map((sProduct, index) => {
                          return (
                            <tr key={sProduct.id}>
                              <td className='text-center'>{index + 1}</td>
                              <td className='text-center'>
                                {moment(sProduct.created_at).format(
                                  'DD-MMM-YYYY'
                                )}
                              </td>
                              <td className='text-center'>
                                {sProduct.payment_item_name}
                              </td>
                              <td className='text-center'>
                                {sProduct.quantity}
                              </td>
                              <td className='text-center'>
                                {sProduct.net_total}
                              </td>

                              <td className='text-center'>
                                {CommonStatus(sProduct.status)}
                              </td>
                              {/* <td className='d-flex gap-2 justify-content-center'>
                                <PopOver
                                  confirm={() => {
                                    mutate({
                                      id: sProduct.id,
                                    });
                                  }}
                                />
                              </td> */}
                            </tr>
                          );
                        })
                      ) : (
                        <tr className='text-center'>
                          <td colSpan={7} className='fw-bold'>
                            No data found
                          </td>
                        </tr>
                      )}
                    </>
                  </tbody>
                </Table>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default AdditionalService;
